import { render, staticRenderFns } from "./wapActBox.vue?vue&type=template&id=5eac4fb8&scoped=true"
import script from "./wapActBox.vue?vue&type=script&lang=js"
export * from "./wapActBox.vue?vue&type=script&lang=js"
import style0 from "./wapActBox.vue?vue&type=style&index=0&id=5eac4fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eac4fb8",
  null
  
)

export default component.exports